import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AssetSelectionComponent } from '@features/shopping/asset/selection/asset-selection.component';
import { UserAsset } from '@models/dashboard.model';
import { getCarrier } from '@models/functions.model';
import { ShoppingCartData } from '@models/shopping-cart.model';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslationPipe } from '@pipes/translation/translation.pipe';
import { ActivityManagerService } from '@services/activity/manager/activity-manager.service';
import { ShoppingService } from '@services/shopping/shopping.service';
import { Subscription } from 'rxjs';
import { DataLoaderService } from 'tangoe-design-system';

@Component({
  selector: 'ts-activity-6-line-selection',
  templateUrl: './line-selection.component.html',
  imports: [TranslationPipe, AssetSelectionComponent, NgbTooltip]
})
export class LineSelectionComponent implements OnInit, OnDestroy {
  asset: UserAsset | undefined;
  shopping_cart: ShoppingCartData;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private shopping_svc: ShoppingService,
    private loader_svc: DataLoaderService,
    private activity_manager_svc: ActivityManagerService
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.shopping_svc.getShoppingItems().subscribe({
        next: (res: ShoppingCartData) => {
          this.shopping_cart = res;
        },
        error: (err: HttpErrorResponse) => {}
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  get userAssetLoading(): boolean {
    return this.loader_svc.isLoading('user-assets');
  }

  selectAsset(asset: UserAsset | undefined): void {
    this.asset = asset;

    this.shopping_svc.sendShoppingItems(this.shoppingCartParam(), true).subscribe({
      next: (res: ShoppingCartData) => {
        this.activity_manager_svc.navigateToNextStep();
      },
      error: (err: HttpErrorResponse) => {}
    });
  }

  private shoppingCartParam(): ShoppingCartData {
    return {
      ...this.shopping_cart,
      country_id:
        this.asset?.line?.country_id ?? this.activity_manager_svc.state().parameter('country')?.id,
      carrier: (this.asset?.line && getCarrier(this.asset.line)) ?? undefined,
      orderTypeId: this.activity_manager_svc.currentOrderTypeId(),
      lineId: this.asset?.line.id ?? undefined,
      existing_asset: {
        ...this.asset!,
        asset_from_inventory: this.asset ? true : false,
        asset_selection_case: this.asset ? 1 : undefined
      },
      progress_stepper: this.activity_manager_svc
        .state()
        .currentStep(this.activity_manager_svc.state().activeStepIndex())
    };
  }
}
